module.exports = __webpack_public_path__ + "static/media/wed_pano_03-min.d39d60f6.JPG";